import { Customer } from "../../../state/types"
import { Link } from "../../../../../features/ui"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"

type Props = {
    customer: Customer
}

export const CustomerLink = (props: Props) => {
    const { customer } = props
    const { getRoutePath } = useRoutesHooks()

    return (
        <Link
            text={customer.name}
            icon="person-fill"
            kind="primary"
            to={getRoutePath(RoutePath.CUSTOMERS, customer.id)}
        />
    )
}
